import { ChangeDetectionStrategy, Component, input, OnDestroy, OnInit, signal } from '@angular/core';
import { ColumnGroup } from 'ag-grid-community';
import { WrapHeaderTextPipe } from '@shared/pipes/wrap-header-text/wrap-header-text.pipe';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ag-grid-group-header-text',
    templateUrl: './ag-grid-group-header-text.component.html',
    styleUrls: ['./ag-grid-group-header-text.component.scss'],
    imports: [WrapHeaderTextPipe],
})
export class AgGridGroupHeaderTextComponent implements OnInit, OnDestroy {
    readonly name = input<string>('');
    readonly columnGroup = input<ColumnGroup>();
    readonly spansMultipleColumns = signal(false);

    private readonly updateSpansMultipleColumns = (): void => {
        this.spansMultipleColumns.set((this.columnGroup()?.getDisplayedLeafColumns().length ?? 0) > 1);
    };

    ngOnInit(): void {
        this.updateSpansMultipleColumns();
        this.columnGroup()?.addEventListener('displayedChildrenChanged', this.updateSpansMultipleColumns);
    }

    ngOnDestroy(): void {
        this.columnGroup()?.removeEventListener('displayedChildrenChanged', this.updateSpansMultipleColumns);
    }
}
